import { getService } from '@/modules/Service/services'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { useParams } from 'react-router-dom'
import { ErrorBoundary } from 'vnetwork-ui'
import Templates from '../../Templates'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const Information = () => {
    const { id: serviceID } = useParams()
    const { data: service, renderState } = useQueryWithHandler({
        queryFn: () => getService(Number(serviceID)),
        queryKey: [QUERY_KEYS.SERVICES_MONITORING, Number(serviceID)],
    })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent
    if (!service) return null

    const ServiceTemplate =
        Templates[service?.service_template] || Templates['Blank']

    const Monitoring =
        // @ts-ignore
        ServiceTemplate?.Monitoring || Templates['Blank']?.Monitoring

    return (
        <ErrorBoundary>
            <Monitoring service={service} />
        </ErrorBoundary>
    )
}

export default Information
